import { ToolbarItem } from '../../../../common/components/ToolbarItem'
import { Group } from '@wellesley/openapi'
import { GroupPreview } from './GroupPreview'
import { GroupApps } from './GroupApps'
import { GroupGeneral } from './GroupGeneral'
import { GroupChannels } from './GroupChannels'
import { useOpenLastApp } from '@wellesley/apps'
import { useCallback } from 'react'
import { selectUploadFile } from '@wellesley/uploads'

type GroupSideBarProps = {
  group: Group
}
export const GroupSideBar = ({ group }: GroupSideBarProps) => {
  const { openLastApp } = useOpenLastApp({ entryPoint: 'GROUP' })

  const handleClick = useCallback(() => {
    void openLastApp({
      groupId: group.groupId,
      groupName: group.groupName,
    })
  }, [openLastApp, group.groupId, group.groupName])

  return (
    <ToolbarItem
      key={group.groupId}
      id={group.groupName}
      name={group.displayName}
      onClick={handleClick}
      Icon={
        selectUploadFile({
          upload: group.avatar,
          size: 16,
          allowWithoutSize: true,
        })?.uri
      }
    >
      <div
        className="flex flex-col"
        data-testid={`group-sidebar-${group.groupName}`}
      >
        <GroupPreview group={group} />
        <div className="flex flex-col gap-xxxs px-xs">
          <GroupApps groupId={group.groupId} groupName={group.groupName} />
          <GroupChannels groupId={group.groupId} groupName={group.groupName} />
          <GroupGeneral group={group} />
        </div>
      </div>
    </ToolbarItem>
  )
}
